import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLitecoinComponent } from './simple-icons-litecoin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLitecoinComponent ],
    exports:      [ SimpleIconsLitecoinComponent ],
    bootstrap:    []
})
export class SimpleIconsLitecoinModule {}
